var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocumentUploader = function SvgDocumentUploader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#documentUploader_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C29B40",
    fillOpacity: 0.16,
    d: "M18.97 24.5H5.03c-1.1 0-1.992-.892-1.992-1.992V2.492C3.037 1.392 3.93.5 5.03.5h9.14c.51 0 1 .195 1.37.545l4.8 4.542c.398.376.623.9.623 1.447v15.474c0 1.1-.891 1.992-1.991 1.992"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C29B40",
    fillOpacity: 0.16,
    d: "m20.34 5.587-4.801-4.542c-.37-.35-.86-.545-1.37-.545H12v24h6.971c1.1 0 1.992-.892 1.992-1.992V7.034c0-.548-.226-1.07-.623-1.447"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C29B40",
    d: "M15.685 6.475h5.197a2 2 0 0 0-.542-.888l-4.801-4.542a2 2 0 0 0-.85-.476v4.91c0 .55.446.996.996.996"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.831 11.281H6.17c-.404 0-.731-.315-.731-.703s.327-.703.73-.703h11.663c.404 0 .732.315.732.703s-.328.703-.732.703M17.831 15.031H6.17c-.404 0-.731-.315-.731-.703s.327-.703.73-.703h11.663c.404 0 .732.315.732.703s-.328.703-.732.703M10.183 18.781H6.169c-.404 0-.731-.315-.731-.703s.327-.703.73-.703h4.015c.403 0 .73.315.73.703s-.327.703-.73.703"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.563 10.578c0-.388-.328-.703-.732-.703H12v1.406h5.831c.404 0 .732-.315.732-.703M17.831 13.625H12v1.406h5.831c.404 0 .732-.315.732-.703s-.328-.703-.732-.703"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "documentUploader_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h24v24H0z"
  })))));
};
export default SvgDocumentUploader;